import { render } from "./CatalogsViewsContainer.vue?vue&type=template&id=ed90d320"
import script from "./CatalogsViewsContainer.vue?vue&type=script&lang=js"
export * from "./CatalogsViewsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__